import styled from "styled-components";

export const StyledAdvancedSearchButton = styled.button`
	display: flex;
	align-items: center;
	border: none;
	background: none;
	cursor: pointer;
	font-weight: 300;
	text-transform: uppercase;
	img {
		margin-right: 0.8rem;
	}
`;
